import {JobPositions} from "../constants/JobPositions";
import {i18n} from "keysso/plugins/i18n";

export class QualificationsHelper
{
    /**
     * Должность по ID
     * @param {Number} positionId
     * @returns {String}
     */
    static getPositionLabelById(positionId)
    {
        const allPositions = this.#mappingPositions();
        return allPositions[positionId] ?? '';
    }

    /**
     * Опции для выпадающего списка
     * @returns {{
     *     id: Number,
     *     caption: String,
     * }[]}
     */
    static getPositionsOptions()
    {
        const allPositions = this.#mappingPositions();
        return Object.entries(allPositions).map(([id, caption]) => ({
            id,
            caption,
        }));
    }

    static #mappingPositions()
    {
        return {
            [JobPositions.SEO]: i18n.global.t('lang.pages.qualification.job.company_position.seo'),
            [JobPositions.MARKET]: i18n.global.t('lang.pages.qualification.job.company_position.market'),
            [JobPositions.ADS]: i18n.global.t('lang.pages.qualification.job.company_position.ads'),
            [JobPositions.COPYWRITER]: i18n.global.t('lang.pages.qualification.job.company_position.copywriter'),
            [JobPositions.WEB]: i18n.global.t('lang.pages.qualification.job.company_position.web'),
            [JobPositions.ANALYST]: i18n.global.t('lang.pages.qualification.job.company_position.analyst'),
            [JobPositions.MANAGER]: i18n.global.t('lang.pages.qualification.job.company_position.manager'),
            [JobPositions.EMPLOYER]: i18n.global.t('lang.pages.qualification.job.company_position.employer'),
        };
    }
}
